// @vue/component

export default {
  name: 'DashboardProjectList',

  props: {
    agentList: {
      type: Array,
      default: () => [],
    },

  },
  data() {
    return {
      activeName: 'połączenia',
    };
  },
};
